<template>
  <div>

    <div class="logout-container">
      <el-button @click="logout">登出</el-button>
    </div>

    <div class="chart-title">芒果100分-学习时长统计图</div>

    <div class="top-container">
      <div class="date-container" style="z-index: 1;">
        <label for="start-date">开始日期:</label>
        <input type="date" id="start-date">
        <label for="end-date">结束日期:</label>
        <input type="date" id="end-date">
      </div>
      <button v-on:click="fetchData" style="z-index: 1;">统计学时</button>
    </div>

    <div class="chart-container">
      <div class="chart-wrapper">
        <canvas id="chart"></canvas>
      </div>
      <div id="total-sum">{{ totalSum }}</div>
    </div>

  </div>
</template>



<script>
import { Message } from "element-ui";
import Chart from 'chart.js'
import { search } from "../../api";
export default {
  data() {
    return {
      user: {
        uname: "",
        uid: null,
      },
      chart: null,
      data: {},
      totalSum: "",
    };
  },
  methods: {
    logout() {
      // 移除本地用户登录信息
      this.$cookies.remove("name");
      this.$router.push("/login");
    },
    fetchData() {
      search(this.user.uname)
        .then(json => {
          if (json.code === "200") {
            // 处理成功响应数据
            this.data = json.data.info;

            this.updateChart();
          } else {
            Message.error('暂无数据');
          }
        })
        .catch(error => {
          console.log(error);
          // 处理错误
        });
    },
    formatTime(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var secs = seconds % 60;

      return hours.toString().padStart(2, '0') + ':' +
             minutes.toString().padStart(2, '0') + ':' +
             secs.toString().padStart(2, '0');
    },
    updateChart() {

      var startDate = document.getElementById('start-date').value;
      var endDate = document.getElementById('end-date').value;

      var filteredData = {};
      for (var date in this.data) {
        if (date >= startDate && date <= endDate) {
          filteredData[date] = this.data[date];
        }
      }

      var labels = Object.keys(filteredData);
      var values = Object.values(filteredData);

      var sum = values.reduce((total, value) => total + value, 0);
      this.totalSum = '学习时长总和: ' + this.formatTime(sum);
      if (this.chart) {
        this.chart.destroy();
      }
      var barChart = document.getElementById('chart').getContext('2d');
      this.chart = new Chart(barChart, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{
            label: '学习时长统计',
            data: values,
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function(value) {
                  return this.formatTime(value);
                }.bind(this)
              }
            }
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: function(context) {
                  var value = context.parsed.y;
                  return '学习时长: ' + this.formatTime(value);
                }.bind(this)
              }
            }
          }
        }
      });
    },
  },
mounted() {
    this.user.uname = this.$cookies.get("name");
    this.user.uid = this.$cookies.get("uid");

    this.today = new Date();
    this.startDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 6).toISOString().split('T')[0];
    this.endDate = this.today.toISOString().split('T')[0];

    this.$nextTick(() => {
      document.getElementById('start-date').value = this.startDate;
      document.getElementById('end-date').value = this.endDate;
    });
  },
};
</script>


<style scoped>

.chart-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-weight: bold;
  font-size: 24px;
}

.top-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.date-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}

.logout-container {
  position: absolute;
  top: 10px;
  right: 10px;
}

.chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 100%; /* 设置容器的宽度 */
  height: 100vh; /* 设置容器的高度，这里使用视口高度 */
}

.chart-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 800px; /* 设置图表包装器的宽度，放大两倍 */
  height: 800px; /* 设置图表包装器的高度，放大两倍 */
  transform: scale(1); /* 放大两倍 */
}


#chart {
  /* 设置图表的样式 */
}

#chart {
  width: 100%; /* 设置图表的宽度 */
  height: 100%; /* 设置图表的高度 */
}
#total-sum {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/pages/Home/HomeChart.vue